import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllCategories } from "../../redux/Slices/CategorySlice";
import { GetAllBrands } from "../../redux/Slices/BrandsSlice";
import { getSubCatONMainCat, getsubCatDetails } from "../../redux/Slices/SubCategorySlice";
import { EditProduct, getProductDetails } from "../../redux/Slices/ProductSlice";
import notify from "../UseNotification";
import { useNavigate, useParams } from "react-router-dom";

const UseEditProduct = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const allCategory = useSelector((state) => state.CategoryReducer.AllCategories);
  const AllBrands = useSelector((state) => state.BrandsReducer.AllBrands);
  const { SubCategory, subCatDetails } = useSelector((state) => state.SubCategoryReducer);
  const { productDetails, editProduct } = useSelector((state) => state.ProductReducer);

  const [ProductDetailsLoading, setProductDetailsLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [AllCategoriesLoading, setAllCategoriesLoading] = useState(true);
  const [brandsLoading, setAllbrandsLoading] = useState(true);
  const [subcategoriesId, setSubcategoriesId] = useState("");
  const [imgCover, setImgCover] = useState("");
  const [images, setImages] = useState([]);
  const [productName, setProductName] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [priceBeforeDiscount, setPriceBeforeDiscount] = useState("");
  const [productprice, setProductprice] = useState("");
  const [categoryValue, setCategoryValue] = useState("0");
  const [BrandValue, setBrandValue] = useState("0");
  const [toggleColor, setToggleColor] = useState(false);
  const [qty, setQty] = useState("");
  const [colors, setColors] = useState([]);
  const [isImagesChanged, setIsImagesChanged] = useState(false);
  const [isValidate, setIsValidate] = useState(false);
  const [isPress, setIspress] = useState(false);

  // dispatch get product details
  const handleGetProductDetails = async () => {
    setProductDetailsLoading(true)
    await dispatch(getProductDetails(id));
    setProductDetailsLoading(false)
  }

  // dispatch get All Categories 
  const handleGetAllCategories = async () => {
    setAllCategoriesLoading(true)
    await dispatch(GetAllCategories(`page="1"`));
    setAllCategoriesLoading(false)
  }

  // dispatch get All Brands 
  const handleGetAllBrands = async () => {
    setAllbrandsLoading(true)
    await dispatch(GetAllBrands(`page="1"`));
    setAllbrandsLoading(false)
  }

  // dispatch all categories & brands & product details
  useEffect(() => {
    handleGetProductDetails();
    handleGetAllCategories();
    handleGetAllBrands();
  }, []);

  // to display product details on inputs
  useEffect(() => {
    if (ProductDetailsLoading === false) {
      if (productDetails && productDetails.data) {
        setImgCover(productDetails.data.data.imageCover)
        setImages(productDetails.data.data.images);
        setProductName(productDetails.data.data.title);
        setProductDescription(productDetails.data.data.description);
        setQty(productDetails.data.data.quantity);
        setPriceBeforeDiscount(productDetails.data.data.price);
        setProductprice(productDetails.data.data.priceAfterDiscount);
        setCategoryValue(productDetails.data.data.category);
        setOptions(productDetails.data.data.subcategory)
        setBrandValue(productDetails.data.data.brand);
        setColors(productDetails.data.data.availableColors);
        setSubcategoriesId(productDetails.data.data.subcategory)
      }
    }
  }, [ProductDetailsLoading]);


  // check if the image object is empty or not 
  const IsObjectEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };
  const prevImages = useRef(images);

  useEffect(() => {
    // Compare the current images with the previous images
    if (!IsObjectEmpty(images)) {
      if (images !== prevImages.current) {
        setIsImagesChanged(true);
      } else {
        setIsImagesChanged(false);
      }
      prevImages.current = images;
    }

  }, [images]);

  useEffect(() => {
    if (isImagesChanged === true) {
      setIsValidate(true);
    } else {
      setIsValidate(false);
    }

  }, [isImagesChanged]);

  // to set product name
  const OnChangeProductName = (e) => {
    e.persist();
    setProductName(e.target.value);
    if (e.target.value === "") {
      setIsValidate(false)
    } else {
      setIsValidate(true)
    }
  };

  // to set product description
  const onChangeProductDescription = (e) => {
    e.persist();
    setProductDescription(e.target.value);
    if (e.target.value === "") {
      setIsValidate(false)
    } else {
      setIsValidate(true)
    }
  };

  // to set qty products
  const onChangeqty = (e) => {
    e.persist();
    setQty(e.target.value);
    if (e.target.value === "") {
      setIsValidate(false)
    } else {
      setIsValidate(true)
    }
  };

  // set Price before discount
  const onChangePriceBeforeDiscount = (e) => {
    e.persist();
    setPriceBeforeDiscount(e.target.value);
    if (e.target.value === "" || e.target.value <= productprice) {
      setIsValidate(false)
    } else {
      setIsValidate(true)
    }
  };


  // set product price
  const onChangeProductprice = (e) => {
    e.persist();
    setProductprice(e.target.value);
  };


  // set Category value
  const onChangeCategoryValue = (e) => {
    e.persist();
    setCategoryValue(e.target.value);
    if (e.target.value === "") {
      setIsValidate(false)
    } else {
      setIsValidate(true)
    }
  };

  // set brand value
  const onChangeBrandValue = (e) => {
    e.persist();
    setBrandValue(e.target.value);
    if (e.target.value === "") {
      setIsValidate(false)
    } else {
      setIsValidate(true)
    }
  };

  // toggle color option
  const onToggleColor = () => {
    setToggleColor(!toggleColor);
  };

  // save Color Value
  const SaveColorValue = (color) => {
    setColors([...colors, color.hex]);
    setToggleColor(!toggleColor);
  };

  // to delete color
  const deleteColor = (color) => {
    const newColores = colors.filter((e) => e !== color);
    setColors(newColores);
  };

  // validate Product Name
  const validateProductName = (e) => {
    if (e.target.value === "") (
      notify("Please enter product name", "error")
    )
  }

  // validate Product Description
  const validateProductDescription = (e) => {
    if (e.target.value === "") (
      notify("Please enter product Description", "error")
    )
  }

  // validate Product qty
  const validateProductqty = (e) => {
    if (e.target.value === "") (
      notify("Please enter product quantity", "error")
    )
  }

  // validate Price Before Discount
  const validatePriceBeforeDiscount = (e) => {
    if (e.target.value === "") (
      notify("Please enter price before discount ", "error")
    )
  }

  // validate Product price
  const validateProductprice = (e) => {
    
  }


  // convert image from base 64 to file to we can save it
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  //convert url to file
  const convertURLtoFile = async (url) => {
    const response = await fetch(url, { mode: "cors" });
    const data = await response.blob();
    const ext = url.split(".").pop();
    const filename = url.split("/").pop();
    const metadata = { type: `image/${ext}` };
    return new File([data], Math.random(), metadata);
  };




  // submit form
  const SubmitForm = async (e) => {
    e.preventDefault();
    setIspress(true)
    let imgCover = null;
    let itemImages = [];
    let formData = new FormData();
    if (images && images[0].length <= 1000) {
      imgCover = await convertURLtoFile(images[0]).then(val => imgCover = val)
    } else {
      imgCover = dataURLtoFile(images[0], Math.random() + ".png")
    }
    // convert array of base 64 image to file 
    Array.from(Array(Object.keys(images).length).keys()).map(
      (item, index) => {
        if (images[index].length <= 1000) {
          convertURLtoFile(images[index]).then(val => itemImages.push(val))
        }
        else {
          itemImages.push(dataURLtoFile(images[index], Math.random() + ".png"))
        }
      })
    // let imagesArray = Object.keys(images)
    formData.append("title", productName)
    formData.append("description", productDescription)
    formData.append("quantity", qty)
    formData.append("category", categoryValue)
    formData.append("price", priceBeforeDiscount)
    formData.append("brand", BrandValue)
    formData.append("imageCover", imgCover)
    formData.append("priceAfterDiscount", productprice);
    itemImages.map((item) => formData.append("images", item))
    colors.map((color) => formData.append("availableColors", color))
    selectedSubCat.map((item) => formData.append("subcategory", item._id))
    setLoading(true)
    await dispatch(EditProduct({ id: id, data: formData }))
    setLoading(false)
  };

  useEffect(() => {
    if (loading === false && editProduct && editProduct.status === 200) {
      notify("Product uploaded", "success")
      navigate("/admin/allproducts")
    }
  }, [loading])
  // handle edit product request response
  // useEffect(() => {
  //   if (loading === false) {
  //     if (editProduct && editProduct.data){
  //       notify("Product edited","success")
  //     }else if (editProduct && editProduct.response.status === 500){
  //       notify("Server error","error")
  //     }
  //   }
  // }, [loading])
  // states values 
  const [selectedSubCat, setSelectedSubCat] = useState([]);
  const [options, setOptions] = useState([]);

  // useEffect(() => {
  //   if (productDetails.data) {
  //     subcategoriesId.forEach((id) => {
  //       dispatch(getsubCatDetails(id));
  //     });
  //   }
  // }, [subcategoriesId])

  // useEffect(()=>{
  //   // getSelectedItems()
  // },[])

  // let subCatDetailsData = []
  // subCatDetailsData.push(subCatDetails.name)
  // useEffect(()=>{
  //   setSelectedSubCat(subCatDetails.name)
  // },[subCatDetails])
  // subCatDetailsData = selectedSubCat


  // get selected subCategory
  const onSelect = (selectedValue) => {
    setSelectedSubCat(selectedValue);
  };
  const onRemove = (selectedValue) => {
    setSelectedSubCat(selectedValue);
  };
  const multiselectRef = useRef();

  const resetValues = () => {
    if (multiselectRef.current) {
      multiselectRef.current.resetSelectedValues();
    }
  };
  useEffect(() => {
    dispatch(getSubCatONMainCat(categoryValue));
  }, [categoryValue]);


  useEffect(() => {
    if (categoryValue != 0) {
      if (SubCategory.length >= 1) {
        setOptions(SubCategory);
      }
    }
  }, [SubCategory]);



  return [
    imgCover,
    isImagesChanged,
    loading,
    isPress,
    isValidate,
    images,
    selectedSubCat,
    onSelect,
    onRemove,
    setImages,
    productName,
    OnChangeProductName,
    productDescription,
    onChangeProductDescription,
    priceBeforeDiscount,
    onChangePriceBeforeDiscount,
    productprice,
    onChangeProductprice,
    categoryValue,
    onChangeCategoryValue,
    BrandValue,
    onChangeBrandValue,
    allCategory,
    AllBrands,
    SubmitForm,
    onToggleColor,
    toggleColor,
    SaveColorValue,
    colors,
    deleteColor,
    options,
    qty,
    onChangeqty,
    multiselectRef,
    validateProductName,
    validateProductDescription,
    validateProductqty,
    validatePriceBeforeDiscount,
    validateProductprice
  ];
};

export default UseEditProduct;
